import React, { useContext } from "react";
import { ChevronDownIcon, QuestionMarkIcon } from "../utils/miscIcons";
import { useOrderCalculations } from "../func/orderCalculations";
import ProductsList from "./productsList";
import DiscountInput from "./inputs/discountInput";
import Separator from "./Separator";
import ExtendedWarrantyCheckbox from "./ExtendedWarrantyCheckbox";
import { TemplateContext } from "../layout";
import TotalSavings from "./orderSummary/TotalSavings";
import { useFreeShipping } from "../dev/useFreeShipping.js";

const orderOverviewDrawerV3 = () => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const summary = window.post_template?.checkout_v4_summary;
  const shippingPolicyUrl = summary.checkout_v4_summary_shippingLink;
  const isDiscountApplied =
    templateContext.discountCode &&
    templateContext.discountCode.toLowerCase() === window.productData?.discount_codes?.discount_code.toLowerCase();
  const MultiplyWarranty = window.productData.multiply_price_by_amount;
  const warrantyState = templateContext.config.warrantyState;
  const bundleMode = window.productData.show_bundle_design;

  // function returns total, subtotal, shipping prices and total savings.

  const orderCalculations = useOrderCalculations(
    templateContext?.config?.product,
    isDiscountApplied,
    MultiplyWarranty,
    warrantyState,
    bundleMode
  );

  const { isEnabled, isActive } = useFreeShipping();

  const freeShippingLabel = isActive
    ? summary.tr_checkout_v4_summary_free_shipping_applied_label
    : summary.tr_checkout_v4_summary_free_shipping_expired_label;

  return (
    <div className="orderOverviewDrawerV3">
      <div
        data-cy="cc-order-summary-container"
        className={`orderOverviewDrawerV3__topCont ${
          templateContext.orderOverviewDrawerOpen && "orderOverviewDrawerV3__topCont__hide"
        }`}
      >
        <div className={`orderOverviewDrawerV3__savingsLabel__cont`}>
          <div className="orderOverviewDrawerV3__savingsLabel">{summary.tr_checkout_v4_summary_savingsLabel}</div>
          <div className="orderOverviewDrawerV3__savingsLabel">{orderCalculations.savings}</div>
        </div>
        {isEnabled && isActive && (
          <div className="orderOverviewDrawerV3__freeShippingLabelTop">
            {summary.tr_checkout_v4_summary_free_shipping_applied_label}
          </div>
        )}
        <Separator />
      </div>
      <div
        data-cy="cc-order-review-opener"
        className={`orderOverviewDrawerV3__opener ${
          templateContext.orderOverviewDrawerOpen ? "_down" : ""
        } orderOverviewDrawerV3_label`}
        onClick={() => {
          setTemplateContext({
            ...templateContext,
            orderOverviewDrawerOpen: !templateContext.orderOverviewDrawerOpen,
          });
        }}
      >
        <div className="orderOverviewDrawerV3_label_title">
          <span style={{ marginRight: "8px" }}>
            {window.post_template.checkout_v4_summary.tr_checkout_v4_order_review_accordion_title}
          </span>{" "}
          <ChevronDownIcon />
        </div>
        <div className="orderOverviewDrawerV3_label_priceContainer">
          <div className="orderOverviewDrawerV3_label_price">{orderCalculations.total}</div>
        </div>
      </div>

      <div
        style={templateContext?.displayPopup ? { overflow: "visible" } : {}}
        className={`orderOverviewDrawerV3__content ${
          templateContext.orderOverviewDrawerOpen && "orderOverviewDrawerV3__content__show"
        }`}
      >
        <Separator margin="16px 0px 16px 0px" />
        <ProductsList />
        {window.productData?.add_warranty_for_product && (
          <>
            <Separator margin="16px 0px 16px 0px" />
            <ExtendedWarrantyCheckbox />
          </>
        )}
        <Separator margin="16px 0px 0px 0px" />
        {templateContext.discountsEnabled && (
          <>
            <DiscountInput /> <Separator margin="0px 0px 0px 0px" />
          </>
        )}
        <div className="orderTotals__container" style={{ marginBottom: "0px" }}>
          <div className="orderTotals">
            <div className="orderTotals__item">
              <p>{window.post_template?.checkout_v4_summary.tr_checkout_v4_summary_orderLabel}</p>
              <p data-cy="summary-subtotal">{orderCalculations.subtotal}</p>
            </div>
            <div className="orderTotals__item">
              <p className="orderTotals__item__shippingLabel">
                <span style={{ marginRight: "4px" }}>
                  {window.post_template.checkout_v4_summary.tr_checkout_v4_summary_shippingLabel}
                </span>{" "}
                <a className="orderTotals__item__shippingLabel--link" href={shippingPolicyUrl}>
                  <QuestionMarkIcon />
                </a>
              </p>
              <p data-cy="summary-shipping">{orderCalculations.shipping}</p>
            </div>
            {isEnabled && (
              <div className={`orderOverviewDrawerV3__freeShippingLabelBottom ${!isActive ? "expired" : ""}`}>
                {freeShippingLabel}
              </div>
            )}
          </div>
          <Separator />
          <TotalSavings
            type={templateContext?.totalSavingsStyle}
            label={window.post_template?.checkout_v4_summary?.tr_checkout_v4_summary_savingsLabel}
            savings={orderCalculations.savings}
          />
          <div className="total">
            <div>{window.post_template?.checkout_v4_summary.tr_checkout_v4_summary_totalLabel}</div>
            <div data-cy="summary-total">{orderCalculations.total}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default orderOverviewDrawerV3;
